/** Distance tolerances (world px) for ring and span geometry. */
export const GeometryTolerance = {
	/** A ring whose last point lies this close to its first is closed; a shorter edge is degenerate. */
	ringClosure: 1e-6,
	/** Slack so a span ending exactly where a junction begins is not "overlapping". */
	spanTouch: 0.01,
} as const;
